import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Typography, Button, Box } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
    bannerContainer: {
        backgroundImage:
            'url("https://res.cloudinary.com/gift-card-granny/image/upload/f_auto/v1749850308/GCG/assets/promo-banners/Menu_Promo_gx2wxb")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        borderRadius: 8,
        width: '100%',
        padding: '16px 32px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: '92px',
    },
    textContainer: {
        display: 'flex',
        flexDirection: 'column',
        paddingLeft: '10px',
    },
    heading: {
        color: '#ffffff',
        fontWeight: 700,
        fontSize: '32px',
        marginBottom: 0,
        marginTop: '0px',
    },
    subheading: {
        color: '#ffffff',
        fontSize: '15px',
        marginBottom: '0px',
    },
    button: {
        width: 204,
        height: 32,
        backgroundColor: '#0A3A52',
        color: 'white',
        fontWeight: 600,
        borderRadius: 25,
        textTransform: 'none',
        cursor: 'pointer',
        fontSize: '14px',
        '&:hover': {
            backgroundColor: '#0A3A52',
            color: 'white',
        },
    },
}))

const HolidayBanner = () => {
    const classes = useStyles()
    const handleBannerClick = () => {
        window.location.href = '/e-gift-cards-discounts/'
    }

    return (
        <Box
            className={classes.bannerContainer}
            onClick={handleBannerClick}
            style={{ cursor: 'pointer' }}
            aria-label="Shop Father's Day gift card discounts with cashback"
        >
            <div className={classes.textContainer}>
                <Typography variant="subtitle1" className={classes.subheading}>
                    Spring into summer savings
                </Typography>
                <Typography variant="h1" className={classes.heading}>
                    Save up to 10% off select brands
                </Typography>
            </div>
            <Button
                className={classes.button}
                variant="contained"
                onClick={() => {
                    window.location.href = '/e-gift-cards-discounts/'
                }}
            >
                Shop discounts
            </Button>
        </Box>
    )
}

export default HolidayBanner
